import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import * as d3 from 'd3';
import * as wktparse from 'wellknown';
import { stringify } from 'wellknown';
import { DataManager, CustomDynamicView } from '../../store/store-core';
import * as turfAlong from '@turf/along';
import * as turfLength from '@turf/length';
import * as turfNearestPointOnLine from '@turf/nearest-point-on-line';
import { Feature, FeatureCollection, GeometryCollection, Units } from "@turf/helpers";
import { Util } from '../../util';
import { MapPanel } from './panels/panel';
import { MapBox } from './map-box';
import * as screenfull from 'screenfull';
import { SmoothLine } from './smooth-line';
import { addDays, startOfDay } from 'date-fns';
import Config from '../../config';
import { el } from 'date-fns/locale';
import { formatDate, downloadCsv, Panel } from 'wc-lib'

require('../../../icons/play.svg');
require('../../../icons/pause.svg');
require('../../../icons/pipeline.svg');
require('../../../icons/storage.svg');
require('../../../icons/powerplant.svg');
require('../../../icons/summary.svg');
require('../../../icons/mapmarker.svg');
require('../../../icons/fullscreen.svg');
require('wc-lib/icons/close.svg');

@Component({
    template: require('./map.html'),
    name: 'map-component',
    components: {
        'panel': MapPanel,
        'map-box': MapBox,
        'wc-panel': Panel
    },
    filters: {
        toupper: function (val: string) {
            if (!val) return "";
            val = val.toString();
            return val.toUpperCase();
        }
    },
})
export class MapComponent extends Vue {

    geojsonMap = {
        "type": "FeatureCollection", "features": [
            { "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [[[[136.724132, -13.687188], [136.718516, -13.829034], [136.791352, -13.917739], [136.716807, -14.063653], [136.903087, -14.298923], [136.733084, -14.256117], [136.639415, -14.280206], [136.460785, -14.216404], [136.409679, -13.997247], [136.430186, -13.87713], [136.594737, -13.81227], [136.580089, -13.681899], [136.724132, -13.687188]]], [[[130.386485, -11.46852], [130.628184, -11.80462], [130.496349, -11.839044], [130.321056, -11.770196], [130.053477, -11.822849], [130.064301, -11.691339], [130.201508, -11.653497], [130.146983, -11.489028], [130.269786, -11.338149], [130.349946, -11.339451], [130.386485, -11.46852]]], [[[130.506521, -11.277032], [130.573578, -11.275323], [130.691661, -11.422784], [130.888031, -11.313165], [131.009776, -11.354913], [131.274425, -11.18963], [131.427745, -11.249688], [131.47462, -11.390558], [131.432384, -11.607029], [131.293142, -11.724054], [130.979991, -11.926446], [130.712576, -11.799493], [130.496593, -11.649509], [130.365977, -11.232354], [130.506521, -11.277032]]], [[[138.000188, -16.54161], [138.000187, -18.030269], [138.000187, -19.210972], [138.000187, -19.801427], [138.000187, -20.981975], [138.000187, -21.572378], [138.000187, -22.752926], [138.000187, -23.933629], [138.000187, -24.524084], [138.000187, -25.999911], [136.875191, -25.999911], [136.031418, -25.999911], [134.906422, -25.999911], [133.500203, -25.999911], [132.937653, -25.999911], [131.812658, -25.999911], [130.687662, -25.999911], [129.84394, -25.999911], [129.000116, -25.999911], [129.000116, -24.956513], [129.000116, -23.913217], [129.000116, -23.217652], [129.000116, -22.174305], [129.000116, -21.478792], [129.000116, -20.087714], [129.000116, -18.696585], [129.000116, -18.000916], [129.000116, -16.957621], [129.000116, -15.566595], [129.000116, -14.868151], [129.173188, -14.964776], [129.221446, -14.84352], [129.476573, -14.93377], [129.611827, -14.94256], [129.724132, -14.790704], [129.606781, -14.671563], [129.585216, -14.566339], [129.358084, -14.408787], [129.49586, -14.089125], [129.71754, -14.015558], [129.714854, -13.880548], [129.815929, -13.761977], [129.785492, -13.675714], [129.837738, -13.510512], [129.968923, -13.53045], [130.163748, -13.432875], [130.273204, -13.31878], [130.118663, -13.156183], [130.129893, -12.940525], [130.246755, -12.937758], [130.351817, -12.842462], [130.344981, -12.695001], [130.579438, -12.568455], [130.620372, -12.436944], [130.783865, -12.434991], [130.897634, -12.334242], [131.025157, -12.360528], [131.000173, -12.171319], [131.116384, -12.15488], [131.216482, -12.214939], [131.327891, -12.185317], [131.492931, -12.297784], [131.784353, -12.27044], [131.904633, -12.219822], [132.045665, -12.307387], [132.268809, -12.180841], [132.439626, -12.15488], [132.627208, -12.043878], [132.651052, -11.865818], [132.593028, -11.784438], [132.695567, -11.653497], [132.594981, -11.622003], [132.495372, -11.47617], [132.369884, -11.434991], [132.084727, -11.517999], [131.856212, -11.303399], [132.014334, -11.139581], [132.188324, -11.351251], [132.240977, -11.196466], [132.349946, -11.146254], [132.474946, -11.234145], [132.674164, -11.508396], [132.759532, -11.492364], [132.910981, -11.331801], [133.011078, -11.432794], [133.141124, -11.674574], [133.261241, -11.729587], [133.34669, -11.688246], [133.478526, -11.790785], [133.622081, -11.833266], [133.802501, -11.714939], [133.843761, -11.855239], [133.943126, -11.91367], [134.132172, -11.886407], [134.189708, -12.018243], [134.285004, -11.968194], [134.382172, -12.042657], [134.604666, -12.049493], [134.768565, -11.947686], [134.861095, -12.12656], [134.967052, -12.146091], [135.07016, -12.259942], [135.258311, -12.222101], [135.302948, -12.12831], [135.53528, -12.080621], [135.570717, -11.994575], [135.739268, -11.941502], [135.765391, -12.071873], [135.650073, -12.164576], [135.76531, -12.257094], [135.880138, -12.151625], [136.026134, -12.311456], [136.023204, -12.455662], [136.252696, -12.441095], [136.363943, -12.256443], [136.180024, -12.187758], [136.300466, -12.050714], [136.450713, -11.942333], [136.533289, -11.993246], [136.590575, -12.174278], [136.690603, -12.28281], [136.87638, -12.223414], [136.94934, -12.355869], [136.740245, -12.475763], [136.679222, -12.671292], [136.473806, -12.79225], [136.636944, -12.954941], [136.450531, -13.216404], [136.30836, -13.162774], [136.177419, -13.23561], [136.052419, -13.245294], [135.883365, -13.325764], [135.844837, -13.600186], [136.004893, -13.798028], [135.923106, -13.959649], [135.903331, -14.135837], [135.759125, -14.265395], [135.532258, -14.581084], [135.391287, -14.739923], [135.469574, -14.948012], [135.861013, -15.175958], [135.951671, -15.264418], [136.240082, -15.424086], [136.267914, -15.545017], [136.612071, -15.754653], [136.767914, -15.900811], [137.045909, -15.922296], [137.250255, -16.020603], [137.361176, -16.122166], [137.746104, -16.25213], [137.866873, -16.437107], [138.000188, -16.54161]]], [[[132.586274, -11.039239], [132.627208, -11.246026], [132.493012, -11.166925], [132.586274, -11.039239]]]] }, "properties": { "state": "NT" } },
            { "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [[[[112.959483, -25.482517], [113.137543, -25.885919], [113.046153, -25.940037], [112.919599, -25.631555], [112.959483, -25.482517]]], [[[129.000116, -14.868151], [129.000116, -15.566595], [129.000116, -16.957621], [129.000116, -18.000916], [129.000116, -18.696585], [129.000116, -20.087714], [129.000116, -21.478792], [129.000116, -22.174305], [129.000116, -23.217652], [129.000116, -23.913217], [129.000116, -24.956513], [129.000116, -25.999911], [129.000116, -27.06734], [129.000116, -28.490457], [129.000116, -29.202042], [129.000116, -30.269315], [129.000117, -31.68922], [128.655284, -31.845798], [128.017345, -32.084242], [127.766287, -32.123142], [127.288748, -32.27337], [126.677745, -32.316583], [126.372325, -32.28281], [126.18572, -32.232517], [125.87, -32.332983], [125.537275, -32.548379], [125.337827, -32.601515], [125.000255, -32.737237], [124.901914, -32.833659], [124.708832, -32.903904], [124.356944, -32.952813], [124.116547, -33.121515], [124.008311, -33.354181], [123.952485, -33.567315], [123.756847, -33.714125], [123.73878, -33.794041], [123.566661, -33.884373], [123.343598, -33.903497], [123.146983, -34.00213], [123.084972, -33.878351], [122.787852, -33.881036], [122.560313, -33.959161], [122.312266, -33.9249], [122.187266, -34.020685], [122.015636, -33.825372], [121.812999, -33.895115], [121.532888, -33.819513], [121.333751, -33.815199], [121.166352, -33.867934], [120.572276, -33.891534], [120.422699, -33.969903], [120.002208, -33.926039], [119.806163, -33.984959], [119.572032, -34.142022], [119.382091, -34.440118], [119.116954, -34.472426], [118.931977, -34.445896], [118.727306, -34.558038], [118.705903, -34.647719], [118.479828, -34.717055], [118.38738, -34.825942], [118.119884, -34.987074], [117.684337, -35.046319], [117.538585, -35.092218], [117.359548, -35.024184], [117.171641, -35.013279], [116.899587, -35.050388], [116.465099, -35.000665], [116.248383, -34.877537], [116.019786, -34.82936], [115.745453, -34.540216], [115.612315, -34.445896], [115.334727, -34.314223], [115.017833, -34.26214], [114.971039, -34.082696], [114.956798, -33.682306], [115.118826, -33.616469], [115.282725, -33.650649], [115.434093, -33.595473], [115.66684, -33.287693], [115.674571, -33.024998], [115.600922, -32.661716], [115.769298, -32.602309], [115.714366, -32.302992], [115.756847, -32.185642], [115.743663, -31.92783], [115.680349, -31.648614], [115.4546, -31.303481], [115.312999, -30.990818], [115.180919, -30.827244], [115.101085, -30.633396], [114.974864, -30.214044], [114.942638, -30.03102], [114.967459, -29.902439], [114.946056, -29.658136], [114.97877, -29.479913], [114.832042, -29.092055], [114.652599, -28.912367], [114.577485, -28.785089], [114.589854, -28.655857], [114.531098, -28.522393], [114.310069, -28.230157], [114.166026, -28.106703], [114.097179, -27.819431], [114.143891, -27.687758], [114.012543, -27.315362], [113.764415, -26.918145], [113.590579, -26.675651], [113.297782, -26.397289], [113.24467, -26.240098], [113.45009, -26.200609], [113.598283, -26.518507], [113.694918, -26.61424], [113.8525, -26.544772], [113.884773, -26.342673], [113.684138, -26.221604], [113.577239, -26.089343], [113.557553, -25.940989], [113.420781, -25.728215], [113.532888, -25.618259], [113.760609, -25.904793], [113.70436, -26.148046], [113.795386, -26.206715], [113.935469, -26.191722], [113.969981, -26.33172], [114.103776, -26.447882], [114.234371, -26.316584], [114.191895, -26.195862], [114.258149, -25.988946], [114.258556, -25.841892], [114.155284, -25.789727], [113.928396, -25.449802], [113.802419, -25.171808], [113.713064, -25.124933], [113.610606, -24.892755], [113.60434, -24.728285], [113.439464, -24.53281], [113.385265, -24.249119], [113.459727, -23.910333], [113.599457, -23.633966], [113.737559, -23.527032], [113.782481, -23.327081], [113.748302, -23.162286], [113.811534, -23.051365], [113.759776, -22.788751], [113.658946, -22.727797], [113.646658, -22.577732], [113.803966, -22.330824], [113.89796, -22.049249], [114.011485, -21.859959], [114.15919, -21.791925], [114.077485, -22.17547], [114.171397, -22.317478], [114.11085, -22.477716], [114.179698, -22.521742], [114.391938, -22.358005], [114.646739, -21.843357], [114.928966, -21.693943], [115.105154, -21.665216], [115.4546, -21.513767], [115.602712, -21.34352], [115.806163, -21.235447], [115.936697, -21.059015], [116.151541, -20.969985], [116.26588, -20.862563], [116.434744, -20.822361], [116.743175, -20.616876], [116.879649, -20.713067], [117.062511, -20.621677], [117.35377, -20.727716], [117.674815, -20.672133], [117.839366, -20.616876], [117.940684, -20.492771], [118.13559, -20.362074], [118.368826, -20.362074], [118.831798, -20.261977], [119.068533, -19.982843], [119.212413, -19.961196], [119.566661, -20.06878], [119.802257, -19.965753], [120.238292, -19.906834], [120.650564, -19.763279], [120.954356, -19.633722], [121.193533, -19.472426], [121.311534, -19.354099], [121.519379, -19.069594], [121.642589, -18.810235], [121.643891, -18.717055], [121.769054, -18.657403], [121.823741, -18.451837], [121.91033, -18.464451], [122.220388, -18.197198], [122.323985, -18.150567], [122.360688, -18.000177], [122.196137, -17.945408], [122.205414, -17.71087], [122.14324, -17.563653], [122.172048, -17.261163], [122.276052, -17.089288], [122.530447, -16.873956], [122.570567, -16.788507], [122.704275, -16.786716], [122.7588, -16.604425], [122.886404, -16.512302], [123.15089, -16.807712], [123.143321, -16.913751], [123.260427, -17.014744], [123.399669, -17.329278], [123.553966, -17.518976], [123.567638, -17.361993], [123.644298, -17.184747], [123.5796, -17.094008], [123.635916, -16.991388], [123.837087, -17.13242], [123.768077, -16.878513], [123.693126, -16.729913], [123.566173, -16.615981], [123.654063, -16.48447], [123.651622, -16.360284], [123.539724, -16.265232], [123.594981, -16.155938], [123.771007, -16.163344], [123.732677, -16.258966], [123.835216, -16.368259], [123.986013, -16.28631], [124.126231, -16.272231], [124.222667, -16.395603], [124.400157, -16.353123], [124.378429, -16.214939], [124.520356, -16.176446], [124.590017, -16.094171], [124.404307, -15.87477], [124.37794, -15.68727], [124.403331, -15.559259], [124.504242, -15.467462], [124.629649, -15.504978], [124.797862, -15.291925], [124.920421, -15.361017], [125.049815, -15.498224], [125.08961, -15.347263], [124.928884, -15.338149], [124.84197, -15.141209], [125.12615, -15.049493], [125.310802, -15.150649], [125.354503, -14.99391], [125.204275, -14.932061], [125.232921, -14.860528], [125.144298, -14.728448], [125.466319, -14.524835], [125.583832, -14.526544], [125.658051, -14.360284], [125.744151, -14.444757], [125.925059, -14.51865], [126.04127, -14.508722], [126.060883, -14.35003], [126.141287, -14.195489], [126.247732, -14.22324], [126.39031, -14.00506], [126.500987, -13.997247], [126.569184, -14.195245], [126.704845, -14.118097], [126.701182, -14.007094], [126.818207, -13.942641], [126.747406, -13.791762], [126.952891, -13.723565], [127.07016, -13.828058], [127.107432, -13.952813], [127.322439, -13.917413], [127.418468, -13.94199], [127.489268, -14.058364], [127.666026, -14.178399], [127.90561, -14.497491], [128.175304, -14.698419], [128.067068, -15.125177], [128.224457, -15.260186], [128.195811, -15.056817], [128.402599, -14.823012], [128.5324, -14.752862], [129.000116, -14.868151]]]] }, "properties": { "state": "WA" } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[149.381766, -35.348746], [149.186687, -35.380682], [149.086435, -35.610022], [149.106486, -35.827425], [148.948149, -35.887887], [148.792706, -35.707278], [148.770537, -35.493285], [148.825986, -35.313348], [149.10292, -35.145865], [149.381766, -35.348746]]] }, "properties": { "state": "NSW" } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[150.703783, -35.120442], [150.613055, -35.187267], [150.553966, -35.213556], [150.409353, -35.538507], [150.163422, -35.956638], [150.123057, -36.152602], [150.142345, -36.320001], [150.079275, -36.386], [150.065766, -36.566583], [149.903819, -36.928399], [150.019542, -37.22088], [149.95102, -37.284275], [149.972075, -37.510292], [148.893579, -37.074791], [148.216824, -36.801681], [148.161789, -36.57663], [148.031926, -36.237116], [147.996889, -36.059246], [147.713806, -35.939408], [147.556761, -35.996355], [147.396616, -35.966693], [147.306337, -36.051959], [147.124591, -36.045603], [146.931115, -36.115728], [146.624053, -35.993772], [146.43192, -35.98385], [146.216223, -36.055835], [145.959598, -35.977028], [145.744624, -35.964936], [145.572593, -35.8436], [145.334106, -35.876001], [145.008441, -35.867629], [144.890154, -36.076351], [144.740706, -36.135003], [144.422585, -35.913932], [144.324349, -35.7542], [143.77694, -35.418406], [143.595504, -35.360529], [143.581397, -35.249424], [143.406989, -35.178834], [143.331283, -34.962827], [143.36048, -34.806247], [143.142612, -34.699019], [142.7261, -34.603211], [142.642797, -34.787644], [142.556601, -34.774156], [142.385759, -34.533396], [142.406429, -34.356404], [142.25879, -34.272843], [142.235122, -34.191918], [142.025161, -34.112233], [141.748537, -34.103189], [141.567928, -34.21388], [141.241849, -34.076008], [141.000107, -34.018543], [141.000107, -32.769214], [141.000107, -31.826946], [141.000107, -30.570537], [141.000107, -29.942203], [141.000107, -28.999935], [141.971676, -28.999935], [142.943193, -28.999935], [144.40052, -28.999935], [145.372037, -28.999935], [146.343554, -28.999935], [147.31507, -28.999935], [148.286587, -28.999935], [148.971403, -28.999728], [149.093567, -28.84842], [149.416338, -28.68073], [149.484447, -28.58394], [150.019815, -28.600114], [150.298144, -28.53495], [150.449556, -28.646468], [150.793514, -28.635048], [151.045902, -28.734887], [151.077528, -28.836948], [151.287438, -28.920818], [151.315343, -29.099257], [151.422675, -29.154551], [151.554295, -28.955235], [151.762551, -28.947587], [152.025584, -28.875705], [152.067028, -28.703157], [151.967551, -28.536449], [152.163973, -28.437075], [152.539971, -28.317703], [152.751018, -28.35801], [152.846309, -28.325816], [153.116887, -28.350207], [153.192489, -28.259825], [153.382504, -28.237553], [153.506524, -28.149269], [153.591075, -28.268487], [153.563487, -28.46087], [153.630626, -28.661554], [153.605968, -28.867446], [153.453787, -29.035577], [153.340343, -29.322686], [153.369965, -29.396661], [153.321625, -29.697524], [153.203787, -30.129164], [153.050548, -30.473321], [152.987796, -30.734634], [153.087901, -30.92669], [153.059501, -31.07721], [152.980615, -31.165915], [152.934502, -31.482811], [152.845381, -31.569319], [152.692882, -31.885349], [152.609255, -31.945848], [152.510083, -32.161881], [152.52156, -32.427494], [152.235862, -32.606999], [152.189464, -32.758559], [151.834033, -32.864967], [151.670584, -33.06113], [151.625987, -33.191583], [151.424164, -33.527765], [151.34311, -33.548272], [151.292491, -33.891778], [151.168956, -34.110121], [151.027957, -34.200796], [150.924918, -34.330419], [150.918868, -34.486404], [150.833751, -34.782403], [150.753429, -34.858087], [150.776215, -34.986993], [150.703783, -35.120442]], [[149.381766, -35.348746], [149.10292, -35.145865], [148.825986, -35.313348], [148.770537, -35.493285], [148.792706, -35.707278], [148.948149, -35.887887], [149.106486, -35.827425], [149.086435, -35.610022], [149.186687, -35.380682], [149.381766, -35.348746]]] }, "properties": { "state": "NSW" } },
            { "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [[[[137.622895, -35.582127], [137.580821, -35.726821], [137.686046, -35.757501], [137.908539, -35.729099], [138.064708, -35.761], [138.047699, -35.918634], [137.756684, -35.871515], [137.620372, -36.000095], [137.459239, -36.082696], [137.211681, -35.980157], [136.715587, -36.062758], [136.532563, -35.911879], [136.621104, -35.751235], [137.074474, -35.671645], [137.352224, -35.585626], [137.622895, -35.582127]]], [[[141.000107, -34.018543], [140.967241, -34.566107], [140.967551, -35.565529], [140.967861, -37.064611], [140.968174, -38.059426], [140.713552, -38.070571], [140.602387, -38.037774], [140.359874, -37.882094], [140.240571, -37.665948], [140.114268, -37.517511], [139.988048, -37.487074], [139.741547, -37.180841], [139.788341, -37.126235], [139.672048, -36.953383], [139.784841, -36.902032], [139.863536, -36.767267], [139.853689, -36.621759], [139.475434, -35.896417], [139.041352, -35.604099], [139.135427, -35.498305], [139.375499, -35.463962], [139.223155, -35.31878], [138.961192, -35.413832], [138.882009, -35.560642], [138.74586, -35.538751], [138.531261, -35.645929], [138.176768, -35.668227], [138.122732, -35.555352], [138.427419, -35.352634], [138.507335, -35.056573], [138.486501, -34.873468], [138.536306, -34.740899], [138.440196, -34.675551], [138.259939, -34.438409], [138.226573, -34.320489], [138.078136, -34.128351], [138.037771, -34.308038], [137.930919, -34.414809], [137.910411, -34.623956], [137.746918, -35.058852], [137.671397, -35.180841], [137.403494, -35.1242], [137.1692, -35.242283], [136.95338, -35.283949], [136.83546, -35.247735], [136.960948, -35.096449], [137.03061, -34.899835], [137.446137, -34.917413], [137.512706, -34.617771], [137.459483, -34.447524], [137.492198, -34.260186], [137.453868, -34.163995], [137.55421, -34.072035], [137.602061, -33.876642], [137.776622, -33.693536], [137.930919, -33.616469], [137.937492, -33.52784], [137.810444, -33.259985], [137.854991, -33.190606], [138.043956, -33.125095], [137.957774, -33.004653], [137.902354, -32.78753], [137.452159, -33.140069], [137.37672, -33.389907], [137.224864, -33.653253], [136.807465, -33.808364], [136.607432, -33.902927], [136.369395, -34.073419], [136.124848, -34.452895], [135.936778, -34.534601], [135.862071, -34.698175], [136.012462, -34.979669], [135.741466, -34.861017], [135.604015, -34.880141], [135.429535, -34.71266], [135.346446, -34.275567], [135.259532, -33.997979], [135.189789, -33.892999], [134.849864, -33.63836], [134.813975, -33.352797], [134.662364, -33.225518], [134.446056, -33.153985], [134.278819, -33.162693], [134.074067, -32.713962], [134.271495, -32.73211], [134.273285, -32.588067], [134.148285, -32.456964], [133.853689, -32.529718], [133.949962, -32.389418], [133.812266, -32.247166], [133.586192, -32.103123], [133.411794, -32.211358], [133.147797, -32.19671], [132.798025, -31.956313], [132.58725, -31.934747], [132.483165, -32.026462], [132.233735, -32.032973], [132.077891, -31.90781], [131.78297, -31.727797], [131.535899, -31.605564], [131.177501, -31.477634], [130.833751, -31.601739], [130.156912, -31.573907], [129.000117, -31.68922], [129.000116, -30.269315], [129.000116, -29.202042], [129.000116, -28.490457], [129.000116, -27.06734], [129.000116, -25.999911], [129.84394, -25.999911], [130.687662, -25.999911], [131.812658, -25.999911], [132.937653, -25.999911], [133.500203, -25.999911], [134.906422, -25.999911], [136.031418, -25.999911], [136.875191, -25.999911], [138.000187, -25.999911], [138.750064, -25.999911], [139.874801, -25.999911], [141.000107, -25.999911], [141.000107, -27.124907], [141.000107, -28.249903], [141.000107, -28.999935], [141.000107, -29.942203], [141.000107, -30.570537], [141.000107, -31.826946], [141.000107, -32.769214], [141.000107, -34.018543]]]] }, "properties": { "state": "SA" } },
            { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[149.972075, -37.510292], [149.78712, -37.55283], [149.666677, -37.700128], [149.479015, -37.785903], [148.943858, -37.789483], [148.724132, -37.8235], [148.306407, -37.823419], [147.916515, -37.918552], [147.589366, -38.080662], [147.395518, -38.220147], [146.878591, -38.644301], [146.411794, -38.739841], [146.255707, -38.701755], [146.286388, -38.909845], [146.454112, -38.949314], [146.434337, -39.089125], [146.263845, -38.996026], [146.091807, -38.819757], [145.915782, -38.895766], [145.809337, -38.65016], [145.570811, -38.661716], [145.44809, -38.55047], [145.431163, -38.442804], [145.556895, -38.385186], [145.476573, -38.244887], [145.29656, -38.231703], [145.024669, -38.49391], [144.886404, -38.48211], [144.803966, -38.379083], [144.982921, -38.341404], [145.119314, -38.159356], [145.110199, -38.05169], [144.982677, -37.899347], [144.804454, -37.940851], [144.523285, -38.084242], [144.725108, -38.164809], [144.652843, -38.285821], [144.401866, -38.301202], [144.052501, -38.485772], [143.8449, -38.691176], [143.7046, -38.728123], [143.536957, -38.858331], [143.334483, -38.755955], [143.241547, -38.762791], [143.060069, -38.635919], [142.810232, -38.578383], [142.653819, -38.472752], [142.397716, -38.36712], [142.22462, -38.405694], [141.946788, -38.282892], [141.672537, -38.284275], [141.60141, -38.392267], [141.434418, -38.375095], [141.374766, -38.291192], [141.134288, -38.127618], [140.968174, -38.059426], [140.967861, -37.064611], [140.967551, -35.565529], [140.967241, -34.566107], [141.000107, -34.018543], [141.241849, -34.076008], [141.567928, -34.21388], [141.748537, -34.103189], [142.025161, -34.112233], [142.235122, -34.191918], [142.25879, -34.272843], [142.406429, -34.356404], [142.385759, -34.533396], [142.556601, -34.774156], [142.642797, -34.787644], [142.7261, -34.603211], [143.142612, -34.699019], [143.36048, -34.806247], [143.331283, -34.962827], [143.406989, -35.178834], [143.581397, -35.249424], [143.595504, -35.360529], [143.77694, -35.418406], [144.324349, -35.7542], [144.422585, -35.913932], [144.740706, -36.135003], [144.890154, -36.076351], [145.008441, -35.867629], [145.334106, -35.876001], [145.572593, -35.8436], [145.744624, -35.964936], [145.959598, -35.977028], [146.216223, -36.055835], [146.43192, -35.98385], [146.624053, -35.993772], [146.931115, -36.115728], [147.124591, -36.045603], [147.306337, -36.051959], [147.396616, -35.966693], [147.556761, -35.996355], [147.713806, -35.939408], [147.996889, -36.059246], [148.031926, -36.237116], [148.161789, -36.57663], [148.216824, -36.801681], [148.893579, -37.074791], [149.972075, -37.510292]]] }, "properties": { "state": "VIC" } },
            { "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [[[[153.286143, -24.736505], [153.302257, -24.929457], [153.373546, -25.011814], [153.160655, -25.463149], [153.083507, -25.665785], [152.948253, -25.552179], [153.068533, -25.329034], [153.038341, -25.183526], [153.226085, -25.02752], [153.239594, -24.913263], [153.163259, -24.812433], [153.286143, -24.736505]]], [[[151.036876, -23.45086], [151.191417, -23.513849], [151.297618, -23.748224], [151.213878, -23.77809], [150.979607, -23.487386], [151.036876, -23.45086]]], [[[139.697276, -16.447686], [139.610525, -16.553155], [139.466563, -16.56699], [139.444672, -16.664646], [139.302094, -16.724542], [139.136974, -16.697198], [139.287852, -16.470636], [139.60377, -16.39837], [139.697276, -16.447686]]], [[[153.506524, -28.149269], [153.382504, -28.237553], [153.192489, -28.259825], [153.116887, -28.350207], [152.846309, -28.325816], [152.751018, -28.35801], [152.539971, -28.317703], [152.163973, -28.437075], [151.967551, -28.536449], [152.067028, -28.703157], [152.025584, -28.875705], [151.762551, -28.947587], [151.554295, -28.955235], [151.422675, -29.154551], [151.315343, -29.099257], [151.287438, -28.920818], [151.077528, -28.836948], [151.045902, -28.734887], [150.793514, -28.635048], [150.449556, -28.646468], [150.298144, -28.53495], [150.019815, -28.600114], [149.484447, -28.58394], [149.416338, -28.68073], [149.093567, -28.84842], [148.971403, -28.999728], [148.286587, -28.999935], [147.31507, -28.999935], [146.343554, -28.999935], [145.372037, -28.999935], [144.40052, -28.999935], [142.943193, -28.999935], [141.971676, -28.999935], [141.000107, -28.999935], [141.000107, -28.249903], [141.000107, -27.124907], [141.000107, -25.999911], [139.874801, -25.999911], [138.750064, -25.999911], [138.000187, -25.999911], [138.000187, -24.524084], [138.000187, -23.933629], [138.000187, -22.752926], [138.000187, -21.572378], [138.000187, -20.981975], [138.000187, -19.801427], [138.000187, -19.210972], [138.000187, -18.030269], [138.000188, -16.54161], [138.184255, -16.697198], [138.492686, -16.794366], [138.657237, -16.779718], [138.753429, -16.841241], [139.037283, -16.915623], [139.158051, -17.032973], [139.141612, -17.116876], [139.274181, -17.348321], [139.43865, -17.375665], [139.640961, -17.532403], [139.925304, -17.621352], [139.999522, -17.70615], [140.240489, -17.702081], [140.507498, -17.636326], [140.833263, -17.450779], [140.959972, -17.073989], [140.947032, -17.018324], [141.199474, -16.703058], [141.303966, -16.44199], [141.349783, -16.224298], [141.424815, -16.08172], [141.401703, -15.903578], [141.487071, -15.478936], [141.639008, -15.141209], [141.665701, -15.011407], [141.604259, -14.877699], [141.521658, -14.483819], [141.592052, -14.245294], [141.583995, -14.076104], [141.485037, -13.9485], [141.474132, -13.7763], [141.559825, -13.491957], [141.690766, -13.259861], [141.58546, -12.977472], [141.754731, -12.818455], [141.811371, -12.58408], [141.665701, -12.441095], [141.801036, -12.055108], [141.947602, -11.896173], [142.131847, -11.338149], [142.174571, -10.930108], [142.323416, -10.901625], [142.448578, -10.714532], [142.615001, -10.745375], [142.549571, -10.837986], [142.741954, -10.97503], [142.789806, -11.084893], [142.80128, -11.277765], [142.86964, -11.39129], [142.821056, -11.477634], [142.872895, -11.850681], [142.974294, -11.925226], [143.123383, -11.910577], [143.203949, -11.982517], [143.086274, -12.149021], [143.077159, -12.32879], [143.25294, -12.38893], [143.323497, -12.557794], [143.43393, -12.613051], [143.365082, -12.804864], [143.497244, -12.856541], [143.526622, -13.329767], [143.594574, -13.435805], [143.534434, -13.76572], [143.618419, -13.956231], [143.687266, -14.014337], [143.707774, -14.209568], [143.782725, -14.402276], [143.951996, -14.498956], [144.303559, -14.312595], [144.514903, -14.172784], [144.677582, -14.555841], [144.885997, -14.609633], [144.941742, -14.726332], [145.154796, -14.837498], [145.27711, -14.947035], [145.23585, -15.165948], [145.302582, -15.284601], [145.256358, -15.388849], [145.273774, -15.53574], [145.366384, -15.749282], [145.355805, -15.903416], [145.462413, -16.060479], [145.462413, -16.273207], [145.400401, -16.443292], [145.77768, -16.885349], [145.941661, -16.929946], [145.882335, -17.039727], [145.968435, -17.242364], [146.071056, -17.392022], [146.06837, -17.515883], [146.147716, -17.632582], [146.102712, -17.705987], [146.097911, -17.931329], [146.003673, -18.156427], [146.023774, -18.263116], [146.183442, -18.380141], [146.213715, -18.49212], [146.339366, -18.527032], [146.276622, -18.874282], [146.446544, -19.059747], [146.654796, -19.18255], [146.746349, -19.172784], [146.905121, -19.30462], [146.978201, -19.283868], [147.167247, -19.399998], [147.421397, -19.412774], [147.550466, -19.520929], [147.592052, -19.722101], [147.684255, -19.828058], [147.859223, -19.824884], [147.949474, -19.90781], [148.072439, -19.877048], [148.253917, -19.963474], [148.264903, -20.083103], [148.443858, -20.104181], [148.566661, -20.059991], [148.61085, -20.213637], [148.792328, -20.287286], [148.850841, -20.421075], [148.655284, -20.555434], [148.739757, -20.718927], [149.046235, -20.979913], [149.150645, -20.996189], [149.231212, -21.089776], [149.196137, -21.180922], [149.292979, -21.319268], [149.478282, -21.718438], [149.435395, -21.789727], [149.608572, -22.244317], [149.705089, -22.383884], [149.830821, -22.388604], [150.053559, -22.141534], [150.215587, -22.394789], [150.51295, -22.535414], [150.567638, -22.323175], [150.758311, -22.482354], [150.753184, -22.610528], [150.826427, -22.697931], [150.764415, -23.158868], [150.856619, -23.519952], [151.027442, -23.579997], [151.187185, -23.804132], [151.277843, -23.823907], [151.403656, -23.949965], [151.580577, -24.05755], [151.780447, -24.022556], [151.811371, -24.142348], [151.93336, -24.211033], [152.058604, -24.51393], [152.150401, -24.619073], [152.404796, -24.748712], [152.491466, -24.847589], [152.506033, -24.999444], [152.677094, -25.241876], [152.913829, -25.287693], [152.93865, -25.475681], [152.893809, -25.688165], [153.121593, -25.93377], [153.141775, -26.061456], [153.077485, -26.280857], [153.15089, -26.684747], [153.152517, -26.924981], [153.206228, -27.046075], [153.038422, -27.173435], [153.113617, -27.242364], [153.31544, -27.65488], [153.445567, -27.810479], [153.449474, -28.073175], [153.506524, -28.149269]]], [[[142.283051, -10.714532], [142.153168, -10.755629], [142.118175, -10.653497], [142.21225, -10.597589], [142.283051, -10.714532]]]] }, "properties": { "state": "QLD" } },
            { "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [[[[147.364024, -43.379327], [147.315929, -43.500665], [147.149181, -43.501153], [147.168142, -43.368259], [147.364024, -43.379327]]], [[[144.766287, -40.726495], [144.984711, -40.744806], [145.711599, -40.930434], [145.79127, -41.017022], [146.214366, -41.155369], [146.423676, -41.166192], [147.017589, -40.976658], [147.171072, -41.006524], [147.285981, -40.941339], [147.444835, -41.008396], [147.597423, -40.846856], [147.819835, -40.893487], [147.984223, -40.736505], [148.209321, -40.840753], [148.331391, -41.002211], [148.268891, -41.151625], [148.331065, -41.322524], [148.27947, -41.450372], [148.314952, -41.606541], [148.260997, -41.800388], [148.326915, -41.915785], [148.299327, -42.050551], [148.146983, -41.999282], [147.983409, -42.319024], [148.006033, -42.514093], [147.888682, -42.819513], [148.004731, -42.908868], [147.792491, -43.244073], [147.647797, -43.072849], [147.887055, -43.034438], [147.840343, -42.902032], [147.585623, -42.821222], [147.360199, -42.925226], [147.257579, -43.114353], [147.257579, -43.254327], [147.099783, -43.299412], [146.936046, -43.495212], [146.927013, -43.611749], [146.710704, -43.629002], [146.51352, -43.533949], [146.030772, -43.48268], [146.025401, -43.324884], [145.873302, -43.258396], [145.582286, -42.963556], [145.510265, -42.958429], [145.352712, -42.650811], [145.264171, -42.59531], [145.202403, -42.247491], [145.276866, -42.182061], [145.206554, -41.966567], [144.926036, -41.70908], [144.767345, -41.335545], [144.681651, -41.223077], [144.605805, -40.996515], [144.766287, -40.726495]]], [[[148.400157, -40.361749], [148.295665, -40.434666], [148.082042, -40.454278], [148.074067, -40.35117], [148.345958, -40.309503], [148.400157, -40.361749]]], [[[147.953298, -39.711684], [148.167003, -39.935642], [148.299001, -39.961847], [148.307384, -40.237726], [148.074718, -40.255141], [147.90919, -39.97617], [147.75766, -39.879327], [147.953298, -39.711684]]], [[[144.071462, -40.051202], [143.922537, -40.127374], [143.838145, -39.934503], [143.86199, -39.700616], [144.084158, -39.626153], [144.144786, -39.926446], [144.071462, -40.051202]]]] }, "properties": { "state": "TAS" } }
        ]
    };

    legendItems = [
        { Name: 'Pipeline', Icon: 'pipeline' },
        { Name: 'Production', Icon: 'powerplant' },
        { Name: 'Storage', Icon: 'storage' },
        { Name: 'Compression', Icon: 'compressor' },
        { Name: 'Location', Icon: 'mapmarker' },
    ];

    geojsonBorders = {
        "type": "GeometryCollection", "geometries": [
            { "type": "MultiLineString", "coordinates": [[[138.000188, -16.54161], [138.000187, -18.030269], [138.000187, -19.210972], [138.000187, -19.801427], [138.000187, -20.981975], [138.000187, -21.572378], [138.000187, -22.752926], [138.000187, -23.933629], [138.000187, -24.524084], [138.000187, -25.999911], [136.875191, -25.999911], [136.031418, -25.999911], [134.906422, -25.999911], [133.500203, -25.999911], [132.937653, -25.999911], [131.812658, -25.999911], [130.687662, -25.999911], [129.84394, -25.999911], [129.000116, -25.999911], [129.000116, -24.956513], [129.000116, -23.913217], [129.000116, -23.217652], [129.000116, -22.174305], [129.000116, -21.478792], [129.000116, -20.087714], [129.000116, -18.696585], [129.000116, -18.000916], [129.000116, -16.957621], [129.000116, -15.566595], [129.000116, -14.868151]], [[129.000116, -25.999911], [129.000116, -27.06734], [129.000116, -28.490457], [129.000116, -29.202042], [129.000116, -30.269315], [129.000117, -31.68922]], [[149.381766, -35.348746], [149.186687, -35.380682], [149.086435, -35.610022], [149.106486, -35.827425], [148.948149, -35.887887], [148.792706, -35.707278], [148.770537, -35.493285], [148.825986, -35.313348], [149.10292, -35.145865], [149.381766, -35.348746]], [[149.972075, -37.510292], [148.893579, -37.074791], [148.216824, -36.801681], [148.161789, -36.57663], [148.031926, -36.237116], [147.996889, -36.059246], [147.713806, -35.939408], [147.556761, -35.996355], [147.396616, -35.966693], [147.306337, -36.051959], [147.124591, -36.045603], [146.931115, -36.115728], [146.624053, -35.993772], [146.43192, -35.98385], [146.216223, -36.055835], [145.959598, -35.977028], [145.744624, -35.964936], [145.572593, -35.8436], [145.334106, -35.876001], [145.008441, -35.867629], [144.890154, -36.076351], [144.740706, -36.135003], [144.422585, -35.913932], [144.324349, -35.7542], [143.77694, -35.418406], [143.595504, -35.360529], [143.581397, -35.249424], [143.406989, -35.178834], [143.331283, -34.962827], [143.36048, -34.806247], [143.142612, -34.699019], [142.7261, -34.603211], [142.642797, -34.787644], [142.556601, -34.774156], [142.385759, -34.533396], [142.406429, -34.356404], [142.25879, -34.272843], [142.235122, -34.191918], [142.025161, -34.112233], [141.748537, -34.103189], [141.567928, -34.21388], [141.241849, -34.076008], [141.000107, -34.018543], [141.000107, -32.769214], [141.000107, -31.826946], [141.000107, -30.570537], [141.000107, -29.942203], [141.000107, -28.999935], [141.971676, -28.999935], [142.943193, -28.999935], [144.40052, -28.999935], [145.372037, -28.999935], [146.343554, -28.999935], [147.31507, -28.999935], [148.286587, -28.999935], [148.971403, -28.999728], [149.093567, -28.84842], [149.416338, -28.68073], [149.484447, -28.58394], [150.019815, -28.600114], [150.298144, -28.53495], [150.449556, -28.646468], [150.793514, -28.635048], [151.045902, -28.734887], [151.077528, -28.836948], [151.287438, -28.920818], [151.315343, -29.099257], [151.422675, -29.154551], [151.554295, -28.955235], [151.762551, -28.947587], [152.025584, -28.875705], [152.067028, -28.703157], [151.967551, -28.536449], [152.163973, -28.437075], [152.539971, -28.317703], [152.751018, -28.35801], [152.846309, -28.325816], [153.116887, -28.350207], [153.192489, -28.259825], [153.382504, -28.237553], [153.506524, -28.149269]], [[141.000107, -34.018543], [140.967241, -34.566107], [140.967551, -35.565529], [140.967861, -37.064611], [140.968174, -38.059426]], [[138.000187, -25.999911], [138.750064, -25.999911], [139.874801, -25.999911], [141.000107, -25.999911], [141.000107, -27.124907], [141.000107, -28.249903], [141.000107, -28.999935]]] }
        ]
    };

    flows = [
        { NodeId: 4, FacilityId: 550052, FlowDirection: 'DELIVERY', Point: null },
        { NodeId: 2, FacilityId: 550052, FlowDirection: 'RECEIPT', Point: null },
        { NodeId: 4, FacilityId: 550054, FlowDirection: 'DELIVERY', Point: null },
        { NodeId: 5, FacilityId: 550054, FlowDirection: 'RECEIPT', Point: null }
    ];

    helpUrl: string = Config.helpUrl;
    mapElement: any;
    width = 412;
    height = 362;
    iconSize = 8;
    viewBox = `0 0 ${this.width} ${this.height}`;
    facilitiesData: Array<any> = [];
    graphPipelineData: Array<any> = [];
    graphFacilitiesData: Array<any> = [];
    graphNodeData: Array<any> = [];
    graphNodeLargeData: Array<any> = [];
    graphLocationData: Array<any> = [];
    facilityFlowView: CustomDynamicView<any>;
    locationFlowView: CustomDynamicView<any>;
    facilityFlowData: Array<any> = [];
    locationFlowData: Array<any> = [];
    storageFlowData: Array<any> = [];
    stateFlowData: Array<any> = [];
    shortTermCapacityData: Array<any> = [];
    stateData: Array<any> = [];
    linepackData: Array<any> = [];
    activeTab: string = 'summary';
    activeTabDetails: any;
    tableData: Array<any> = [];
    tabs: Array<any> = [
        { id: 'summary', title: 'Summary', icon: 'summary' },
        { id: 'pipelines', title: 'Pipelines', icon: 'pipeline' },
        { id: 'production', title: 'Production', icon: 'powerplant' },
        { id: 'storage', title: 'Storage', icon: 'storage' }
    ];
    slideshowActive = false;
    isFullscreen = false;
    projection: any;
    path: any;
    arrowOffset = 80;
    flowArrows: Array<any> = [];


    // Summary tab data
    stateDataList: Array<any> = [];
    nationalDemand: number = 0;
    nationalSupply: number = 0;

    get gasDate() {
        return this.$store.getters['app/gasDate'];
    }

    get isActual() {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        if (this.gasDate < today) {
            return true;
        } else {
            return false;
        }
    }

    toggleFullscreen() {
        screenfull.toggle();
    }

    created() {
        this.configureProjection();
        this.activeTab = this.$route.params.view ? this.$route.params.view : 'summary';
        this.updateTabDetails();
        screenfull.onchange(() => {
            this.isFullscreen = screenfull.isFullscreen;
        });
    }

    async mounted() {
        this.mapElement = d3.select(this.$refs.svg);
        await this.onGasDateChange();
        //refresh every 15 minutes
        setInterval(async () => {
            await this.onGasDateChange();
        }, 15 * 60000);
    }

    switchTab(tab: string) {
        this.$router.push({ name: 'map', params: { view: tab } });
        this.activeTab = tab;
        this.updateTabDetails();
    }

    updateTabDetails() {
        this.activeTabDetails = this.tabs.find(x => x.id === this.activeTab);
    }

    slideshowToggle() {
        this.slideshowActive = !this.slideshowActive;

        if (this.slideshowActive) this.slideshow();
    }

    slideshow() {
        if (!this.slideshowActive) return;

        let tabIndex;

        for (tabIndex = 0; tabIndex < this.tabs.length; tabIndex++) {
            if (this.activeTab === this.tabs[tabIndex].id)
                break;
        }

        let nextTab = tabIndex + 1;
        if (nextTab >= this.tabs.length) nextTab = 0;

        this.switchTab(this.tabs[nextTab].id);
        setTimeout(() => this.slideshow(), 30000);
    }

    @Watch('activeTab')
    async tabChange() {
        this.graphFacilitiesData = [];
        this.graphLocationData = []
        await this.retrieveTabData();
        this.updateTab();
    }

    async retrieveTabData() {
        let summaryId = await DataManager.addEndPoint('GasGraph', { EffectiveDate: this.gasDate, GraphType: this.activeTab.toUpperCase() }, undefined, 'data.GasGraph', undefined, 'yyyy-MM-ddTHH:mm:ss', ['EffectiveDate', 'VersionDateTime']);
        let graphFacilitiesView = DataManager.getDynamicView(summaryId, 'mapFacilities');
        graphFacilitiesView.applyFind({ 'EntityType': { '$in': ['FACILITY', 'FACILITY_1', 'FACILITY_2', 'FACILITY_3'] } });
        this.graphFacilitiesData = graphFacilitiesView.data();
        for (let graphElement of this.graphFacilitiesData) {
            graphElement.Geojson = wktparse(graphElement.Geodata);
        }

        let graphLocationsView = DataManager.getDynamicView(summaryId, 'graphLocations');
        graphLocationsView.applyFind({ 'EntityType': 'LOCATION' });
        this.graphLocationData = graphLocationsView.data();
        for (let graphElement of this.graphLocationData) {
            graphElement.Geojson = wktparse(graphElement.Geodata);
        }
    }

    updateTab() {
        for (let graphElement of this.graphFacilitiesData) {
            let facility = this.facilitiesData.find(x => x.FacilityId == graphElement.ReferenceId);
            if (facility) {
                graphElement.FacilityName = facility.FacilityName;
                graphElement.FacilityType = facility.FacilityType;
                graphElement.icon = Util.findIcon(graphElement.FacilityType);
                this.setupFacilityFlowFigure(graphElement, this.facilityFlowData);
            }
        };

        for (let graphElement of this.graphLocationData) {
            this.setupLocationFlowFigure(graphElement);
        }

        this.constructTableData();
    }

    @Watch('gasDate')
    async onGasDateChange() {
        // Reset lists to prevent rendering old data while waiting for API responses
        d3.select('#arrows').selectAll('*').remove();
        this.graphFacilitiesData = [];
        this.tableData = [];
        let result = await Promise.all([
            DataManager.addEndPoint('GasGraph', { EffectiveDate: this.gasDate, GraphType: 'MAP' }, undefined, 'data.GasGraph', undefined, 'yyyy-MM-ddTHH:mm:ss', ['EffectiveDate', 'VersionDateTime']),
            DataManager.addEndPoint('Facilities', { GasDate: this.gasDate }, undefined, 'data.FacilityList', undefined, 'yyyy-MM-ddTHH:mm:ss', ['LastUpdated']),
            DataManager.addEndPoint('States', undefined, undefined, 'data.StateList', undefined, 'yyyy-MM-ddTHH:mm:ssZ', ['LastUpdated']),
            DataManager.addEndPoint('LinepackCapacityAdequacy', { GasDate: this.gasDate }, undefined, 'data.LinepackCapacityAdequacyList', undefined, 'yyyy-MM-ddTHH:mm:ssZ', ['GasDate', 'LastUpdated']),
            this.retrieveTabData(),
            this.retrieveFlowData()
        ]);

        let graphId = result[0];
        let facilitiesId = result[1];
        let stateId = result[2];
        let linepackId = result[3];

        //get facilities from map data
        let graphPipelinesView = DataManager.getDynamicView(graphId, 'mapPipelines');
        graphPipelinesView.applyFind({ 'EntityType': { '$in': ['PIPELINE', 'PIPELINE_SMALL', 'PIPELINE_1', 'PIPELINE_2', 'PIPELINE_3', 'PIPELINE_4'] } });
        this.graphPipelineData = graphPipelinesView.data();

        //get nodes from map data
        let graphNodesView = DataManager.getDynamicView(graphId, 'graphNodes');
        graphNodesView.applyFind({ 'EntityType': { '$in': ['NODE', 'NODE_LARGE'] } });
        this.graphNodeData = graphNodesView.data();

        let facilitiesView = DataManager.getDynamicView(facilitiesId, 'facilities');
        this.facilitiesData = facilitiesView.data();

        let stateView = DataManager.getDynamicView(stateId, 'states');
        this.stateData = stateView.data();

        let linepackView = DataManager.getDynamicView(linepackId, 'linepack');
        this.linepackData = linepackView.data();

        this.populatePipelineLinepackFlag();

        this.buildMapData();

        for (let graphElement of this.graphPipelineData) {
            this.setupFlow(graphElement);
        };

        this.updateTab();
    }
    populatePipelineLinepackFlag() {
        this.graphPipelineData.forEach(pipe => {
            let linepackItem = this.linepackData.find(x => x.FacilityId == pipe.ReferenceId);
            if (linepackItem) {
                pipe.LinepackFlag = linepackItem.Flag.toLowerCase();
            } else {
                pipe.LinepackFlag = 'default';
            }
        });
    }

    buildMapData() {
        this.graphPipelineData.forEach((graphElement, i) => {
            graphElement.Geojson = wktparse(graphElement.Geodata);
            let facility = this.facilitiesData.find(x => x.FacilityId == graphElement.ReferenceId);
            if (facility) {
                graphElement.FacilityName = facility.FacilityName;
            }
        });


        for (let graphElement of this.graphNodeData) {
            graphElement.Geojson = wktparse(graphElement.Geodata);
        }
    }

    constructTableData() {
        let tableData = [];
        if (this.activeTab === 'summary') {
            let stateDataList = this.stateFlowData;

            this.stateDataList = [];
            this.stateDataList.push(this.getStateFromList(stateDataList, 'QLD'));
            this.stateDataList.push(this.getStateFromList(stateDataList, 'NSW'));
            this.stateDataList.push(this.getStateFromList(stateDataList, 'SA'));
            let vicData = this.getStateFromList(stateDataList, 'VIC');
            if (this.isActual) {
                let data = this.facilityFlowData.filter(x => x.FacilityId == '530110' && [590009, 590008, 590005, 590004, 590007, 590006].includes(x.LocationId));
                let demand = data.reduce((acc, x) => acc + x.Demand, 0);
                vicData.Demand = demand;
            } else {
                let data = this.facilityFlowData.filter(x => x.FacilityId == '530110');
                let demand = data.reduce((acc, x) => acc + x.Supply - x.Demand + x.TransferIn - x.TransferOut, 0);
                vicData.Demand = demand;
            }
            this.stateDataList.push(vicData);
            this.stateDataList.push(this.getStateFromList(stateDataList, 'TAS'));
            this.stateDataList.push(this.getStateFromList(stateDataList, 'NT'));

            this.nationalDemand = stateDataList.reduce((acc, x) => acc + Math.round(x.Demand), 0);
            this.nationalSupply = stateDataList.reduce((acc, x) => acc + Math.round(x.Supply), 0);
        } else if (this.activeTab === 'pipelines') {
            for (let graphElement of this.graphFacilitiesData) {
                let capacity;
                let data;
                switch (graphElement.ReferenceId) {
                    case 520053:
                        if (graphElement.flow >= 0) {
                            data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1502045' && x.DeliveryLocation == '1202052');
                            if (data) {
                                capacity = data.OutlookQuantity;
                            } else {
                                capacity = 0;
                            }
                        } else {
                            data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1202038' && x.DeliveryLocation == '1502057');
                            if (data) {
                                capacity = data.OutlookQuantity;
                            } else {
                                capacity = 0;
                            }
                        }
                        break;
                    case 530110:
                        switch (graphElement.EntityType) {
                            case "FACILITY_1":
                                if (graphElement.flow >= 0) {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1303008' && x.DeliveryLocation == '1303084');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                } else {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1303084' && x.DeliveryLocation == '1303007');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                }
                                break;
                            case "FACILITY_2":
                                if (graphElement.flow >= 0) {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1203003' && x.DeliveryLocation == '1303054');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                } else {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1303054' && x.DeliveryLocation == '1203004');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                }
                                break;
                            case "FACILITY_3":
                                data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1303000' && x.DeliveryLocation == '1303046');
                                if (data) {
                                    capacity = data.OutlookQuantity;
                                } else {
                                    capacity = 0;
                                }
                                break;
                            default:
                                break;
                        }
                        break;
                    case 520047:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1302000' && x.DeliveryLocation == '1202003');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 580050:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1808028' && x.DeliveryLocation == '1404296');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 550052:
                        //NCR0166168
                        //data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1305050' && x.DeliveryLocation == '1505012');
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1305050' && x.DeliveryLocation == '1505088');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 550054:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1505013' && x.DeliveryLocation == '1505035');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 570050:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1307000' && x.DeliveryLocation == '1707012');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 540060:
                        switch (graphElement.EntityType) {
                            case "FACILITY_2":
                                if (graphElement.flow >= 0) {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404217' && x.DeliveryLocation == '1504233');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                } else {
                                    data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1504232' && x.DeliveryLocation == '1404216');
                                    if (data) {
                                        capacity = data.OutlookQuantity;
                                    } else {
                                        capacity = 0;
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                        break;
                    case 540057:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404107' && x.DeliveryLocation == '1404090');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 540058:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404003' && x.DeliveryLocation == '1404009');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 540059:
                        //NCR0166168
                        if (graphElement.flow >= 0) { //heading North
                            data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404227' && x.DeliveryLocation == '1404079');//'1404074', '1404076');
                            if (data) {
                                capacity = data.OutlookQuantity;
                            } else {
                                capacity = 0;
                            }
                        } else { //heading South
                            data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404225' && x.DeliveryLocation == '1404074');// '1404227');
                            if (data) {
                                capacity = data.OutlookQuantity;
                            } else {
                                capacity = 0;
                            }
                        }
                        break;
                    case 540092:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404172' && x.DeliveryLocation == '1404160');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 540091:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404143' && x.DeliveryLocation == '1404194');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                    case 540093:
                        data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ' && x.ReceiptLocation == '1404048' && x.DeliveryLocation == '1404050');
                        if (data) {
                            capacity = data.OutlookQuantity;
                        } else {
                            capacity = 0;
                        }
                        break;
                }
                if (capacity != undefined) {
                    let utilisation = 0;
                    if (capacity > 0) {
                        utilisation = Math.abs(graphElement.flow) / capacity * 100;
                    }
                    tableData.push({ name: graphElement.ReferenceName, flow: Math.abs(graphElement.flow), capacity: capacity, utilisation: utilisation });
                }
            }
            console.log(tableData);
            let order = ['APLNG', 'CGP', 'EGP', 'GLNG', 'MAPS', 'MSP', 'NGP', 'PCA', 'QGP', 'RBP', 'SWQP (WAL)', 'TGP', 'LMP', 'SWP', 'VNI', 'WGP'];
            tableData.sort(function (a, b) {
                return order.indexOf(a.name) - order.indexOf(b.name);
            });
        } else if (this.activeTab === 'production') {
            for (let graphElement of this.graphFacilitiesData) {
                let data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'MDQ');
                let capacity = 0;
                let utilisation = 0;
                if (data) {
                    capacity = data.OutlookQuantity;
                    utilisation = graphElement.flow / capacity * 100;
                }
                tableData.push({ name: graphElement.ReferenceName, flow: graphElement.flow, capacity: capacity, utilisation: utilisation });
            }
            let nonMapProductionFacilities = {
                540094: "COMBABULA",
                540095: "ROMA CS",
                540083: "BELLEVUE",
                540084: "Orana",
                540080: "Condabri Central",
                540085: "Reedy Creek",
                540089: "Eurombah Creek",
                580180: "Yelcherr Gas Plant"
            };
            for (let id in nonMapProductionFacilities) {
                let data = this.facilityFlowData.find(x => x.FacilityId == id);
                let referencenName = nonMapProductionFacilities[id];
                let flow;
                let capacity = 0;
                let utilisation = 0;
                if (data) {
                    flow = data.Supply;
                }
                data = this.shortTermCapacityData.find(x => x.FacilityId == id && x.CapacityType == 'MDQ');
                if (data) {
                    capacity = data.OutlookQuantity;
                    if (capacity > 0) {
                        utilisation = flow / capacity * 100;
                    }
                }
                tableData.push({ name: referencenName, flow: flow, capacity: capacity, utilisation: utilisation });
            }
            tableData.sort((a, b) => {
                let order = ['LANG LANG', 'LONGFORD', 'OTWAY', 'MOOMBA', 'BELLEVUE', 'COMBABULA', 'Condabri Central', 'Eurombah Creek', 'FAIRVIEW', 'JORDAN', 'Orana', 'Reedy Creek', 'ROMA CS', 'RUBY JO', 'WOLEEBEE CREEK', 'Yelcherr Gas Plant'];
                return order.indexOf(a.name) - order.indexOf(b.name);
            });
        } else if (this.activeTab === 'storage') {
            for (let graphElement of this.graphFacilitiesData) {
                let data = this.shortTermCapacityData.find(x => x.FacilityId == graphElement.ReferenceId && x.CapacityType == 'STORAGE');
                let capacity = 0;
                let utilisation = 0;
                let balance = this.findLastStorageFigure(graphElement.ReferenceId);
                if (data) {
                    capacity = data.OutlookQuantity;
                    utilisation = balance / capacity * 100;
                }
                tableData.push({ name: graphElement.ReferenceName, flow: graphElement.flow, balance: balance, utilisation: utilisation });
            }
        }
        this.tableData = tableData;
    }

    findLastStorageFigure(referenceId: any) {
        let data = this.storageFlowData.filter(x => x.FacilityId == referenceId)
            .sort((a, b) => a.GasDate > b.GasDate ? -1 : a.GasDate < b.GasDate ? 1 : 0);
        for (let row of data) {
            if (referenceId == 520060 || referenceId == 530038) {
                return (row.HeldInStorage != null ? row.HeldInStorage : 0) + (row.CushionGasStorage != null ? row.CushionGasStorage : 0);
            }
            if (row.HeldInStorage != 0) {
                return row.HeldInStorage;
            }
        }
        return 0;
    }

    setupLocationFlowFigure(graphElement: any) {
        if (graphElement.ReferenceName == 'VIC') {
            if (this.isActual) {
                let data = this.facilityFlowData.filter(x => x.FacilityId == '530110' && [590009, 590008, 590005, 590004, 590007, 590006].includes(x.LocationId));
                let demand = data.reduce((acc, x) => acc + x.Demand, 0);
                graphElement.flow = demand;
            } else {
                let data = this.facilityFlowData.filter(x => x.FacilityId == '530110');
                let demand = data.reduce((acc, x) => acc + x.Supply - x.Demand + x.TransferIn - x.TransferOut, 0);
                graphElement.flow = demand;
            }
        } else {
            let data = this.locationFlowData.find(x => x.LocationId == graphElement.ReferenceId);
            if (data) {
                graphElement.flow = data.Demand;
            }
        }
    }

    setupFacilityFlowFigure(graphElement: any, facilityFlowData: Array<any>) {
        let data;
        switch (graphElement.ReferenceId) {
            //storage facilities
            case 550046:
            case 530038:
            case 530042:
            case 540062:
            case 540040:
            case 520060:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId);
                if (data) {
                    graphElement.flow = data.Demand - data.Supply;
                }
                break;
            //pipelines
            case 520053:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 530110:
                switch (graphElement.EntityType) {
                    case "FACILITY_1":
                        data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530016);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                        }
                        break;
                    case "FACILITY_2":
                        data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590016);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                        }
                        break;
                    case "FACILITY_3":
                        data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 520047:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 550052:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530016);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 550054:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 570050:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 540060:
                switch (graphElement.EntityType) {
                    case "FACILITY_1":
                        data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                        }
                        break;
                    case "FACILITY_2":
                        data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540032);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 540057:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590002);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 540058:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590001);
                if (data) {
                    graphElement.flow = data.Demand;
                }
                break;
            case 540059:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540078);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                }
                break;
            case 540092:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                }
                break;
            case 540091:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                }
                break;
            case 540093:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                }
                break;
            case 580050:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590001);
                if (data) {
                    graphElement.flow = data.TransferOut - data.TransferIn;
                }
                break;
            case 544221:
                break;
            //production facilities
            case 530039:
            case 530040:
            case 540087:
            case 540082:
            case 540088:
            case 540070:
            case 550045:
            case 530044:
            case 540083:
            case 540095:
            case 540094:
                data = facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId);
                if (data) {
                    graphElement.flow = data.Supply;
                }
                break;
            default:
                break;
        }
        if (!graphElement.flow) {
            graphElement.flow = 0;
        }
    }

    setupFlow(graphElement: any) {
        let data;
        let arrows = d3.select('#arrows');
        switch (graphElement.ReferenceId) {
            case 520053:
                switch (graphElement.EntityType) {
                    case "PIPELINE_1":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_2":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590016);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_3":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 520008);
                        let data2 = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590015);
                        if (data && data2) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut
                                + data2.Supply + data2.TransferIn - data2.Demand - data2.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_4":
                        graphElement.flow = 1;
                        this.setupArrow(graphElement, arrows);
                        break;
                    default:
                        break;
                }
                break;
            case 530110:
                switch (graphElement.EntityType) {
                    case "PIPELINE_1":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530016);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_2":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590016);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_3":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 520047:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 550052:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530016);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 550054:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 570050:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 530015);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540060:
                switch (graphElement.EntityType) {
                    case "PIPELINE_1":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 550017);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    case "PIPELINE_2":
                        data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540032);
                        if (data) {
                            graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                            this.setupArrow(graphElement, arrows);
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 540057:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590002);
                if (data) {
                    graphElement.flow = 1;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540058:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 590001);
                if (data) {
                    graphElement.flow = data.Demand;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540059:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540078);
                if (data) {
                    graphElement.flow = data.Supply + data.TransferIn - data.Demand - data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540092:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540091:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 540093:
                data = this.facilityFlowData.find(x => x.FacilityId == graphElement.ReferenceId && x.LocationId == 540030);
                if (data) {
                    graphElement.flow = data.Demand;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            case 544221:
                graphElement.flow = 1;
                this.setupArrow(graphElement, arrows);
                break;
            case 20014:
                data = this.facilityFlowData.find(x => x.FacilityId == 580050 && x.LocationId == 590001);
                if (data) {
                    graphElement.flow = -data.Supply - data.TransferIn + data.Demand + data.TransferOut;
                    this.setupArrow(graphElement, arrows);
                }else{
                    graphElement.flow = 1;
                    this.setupArrow(graphElement, arrows);
                }
                break;
            default:
                break;
        }
    }

    setupArrow(graphElement, arrows) {
        this.$nextTick(() => {
            let path = d3.select(`path#${graphElement.EntityType}-${graphElement.ReferenceId}`);
            let startPoint = path.node().getPointAtLength(0);
            let arrow = arrows.append('path');
            //arrow.attr('d', 'M3 0 L0 2 L0 -2 Z').attr('class', 'flow-arrow').attr("transform", `translate(${startPoint.x} ${startPoint.y})rotate(${angle})`);
            arrow
                .attr('id', `arrow-${graphElement.ReferenceId}-0`)
                .attr('d', 'M0 0 L-1 0.66 L-1 -0.66 Z')
                .attr('class', 'flow-arrow');
            this.repeatFlow(arrow, path, graphElement.flow >= 0);
        });
    }

    repeatFlow(arrow: any, path: any, isPositive: boolean) {
        //let duration = path.node().getTotalLength() * 300;
        let duration = 10000;
        arrow.transition().duration(duration).ease(t => t).attrTween('transform', this.translateAlong(path.node(), isPositive)).on('end', () => { this.repeatFlow(arrow, path, isPositive) });
    }

    translateAlong(path, isPositive) {
        let l = path.getTotalLength();
        return (d, i, a) => {
            return t => {
                let modt, anglemod;
                if (isPositive) {
                    modt = t;
                    anglemod = 0;
                } else {
                    modt = 1 - t;
                    anglemod = 180;
                }
                if (modt < 0.99) {
                    let currentPoint = path.getPointAtLength(modt * l);
                    let currentPointDelta = path.getPointAtLength(modt * l + 0.01);
                    let angle = Util.findAngleBetweenPoints(currentPoint, currentPointDelta) + anglemod;
                    return `translate(${currentPoint.x} ${currentPoint.y})rotate(${angle})`
                } else {
                    let currentPoint = path.getPointAtLength(modt * l - 0.01);
                    let currentPointDelta = path.getPointAtLength(modt * l);
                    let angle = Util.findAngleBetweenPoints(currentPoint, currentPointDelta) + anglemod;
                    return `translate(${currentPoint.x} ${currentPoint.y})rotate(${angle})`
                }
            }
        }
    }

    configureProjection() {
        this.projection = d3.geoMercator()
            .center([135, -29])
            .scale(600)
            .translate([this.width / 2, this.height / 2]);

        this.path = d3.geoPath()
            .projection(this.projection);
    }

    getAllGeometryCoordinates(geometryType: string, geojson: any) {
        if (geojson.type === 'GeometryCollection') {
            let geometry = geojson.geometries.filter(x => x.type === geometryType);
            if (geometry) {
                return geometry;
            }
        } else if (geojson.type === geometryType) {
            return [{ coordinates: SmoothLine.smooth(geojson.coordinates), type: 'LineString' }];

        }
        return [];
    }

    async retrieveFlowData() {
        let flowDataResult;
        let shortTermPromise = DataManager.addEndPoint('ShortTermCapacityOutlook', { FromGasDate: this.gasDate }, 60000, 'data.ShortTermCapacityOutlookList', undefined, 'yyyy-MM-ddTHH:mm:ss', ['GasDate', 'LastUpdated']);
        let previousWeek = addDays(this.gasDate, -6);
        if (this.isActual) {
            flowDataResult = await Promise.all([
                DataManager.addEndPoint('DailyProductionAndFlow', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.DailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('LocationDailyProductionAndFlow', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.LocationDailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('DailyProductionAndFlow', { FromGasDate: previousWeek, ToGasDate: this.gasDate }, 60000, 'data.DailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('StateDailyProductionAndFlow', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.StateDailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                shortTermPromise
            ]);
        } else {
            let currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            let yesterday = addDays(currentDate, -1);
            let rangeForStorage = addDays(yesterday, -6);
            flowDataResult = await Promise.all([
                DataManager.addEndPoint('NominationsAndForecasts', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.NominationsAndForecastsList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('LocationNominationsAndForecasts', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.LocationNominationsAndForecastsList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('DailyProductionAndFlow', { FromGasDate: rangeForStorage, ToGasDate: yesterday }, 60000, 'data.DailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                DataManager.addEndPoint('StateNominationsAndForecasts', { FromGasDate: this.gasDate, ToGasDate: this.gasDate }, 60000, 'data.StateNominationsAndForecastsList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']),
                shortTermPromise
            ]);
        }

        let facilityFlowId = flowDataResult[0];
        let locationFlowId = flowDataResult[1];
        let storageFlowId = flowDataResult[2];
        let stateFlowId = flowDataResult[3];
        let shortTermCapacityId = flowDataResult[4];

        this.facilityFlowView = DataManager.getDynamicView(facilityFlowId, 'facilityFlow');
        this.facilityFlowData = this.facilityFlowView.data();

        this.locationFlowView = DataManager.getDynamicView(locationFlowId, 'locationFlow');
        this.locationFlowData = this.locationFlowView.data();

        let storageFlowView = DataManager.getDynamicView(storageFlowId, 'storageFlow');
        this.storageFlowData = storageFlowView.data();

        let dataView = DataManager.getDynamicView(stateFlowId, 'stateFlow');
        dataView.applyFind({ 'GasDate': { '$dteq': this.gasDate } });
        this.stateFlowData = dataView.data();

        let shortTermCapacityView = DataManager.getDynamicView(shortTermCapacityId, 'shortTerm');
        shortTermCapacityView.applyFind({ 'GasDate': { '$dteq': this.gasDate } });
        this.shortTermCapacityData = shortTermCapacityView.data();
    }

    getStateFromList(stateList: Array<any>, stateShortName: string) {
        let list = stateList.filter(state => state.StateShortName === stateShortName);
        if (list.length > 0) {
            return list[0];
        }

        return { StateShortName: stateShortName, Supply: 0, Demand: 0 };
    }

    downloadCsv(name: string, data: Array<any>, columns: Array<string>) {
        let csv = d3.csvFormatRows([columns].concat(data.map(function (d, i) {
            let csvColumns = [];
            for (let column of columns) {
                let value = d[column];

                if (value instanceof Date) {
                    if (column.toLowerCase() === 'lastupdated') {
                        value = formatDate(value, 'dd/MM/yyyy HH:mm:ss');
                    } else {
                        value = formatDate(value, 'dd/MM/yyyy');
                    }
                }

                csvColumns.push(value);
            }

            return csvColumns;
        })));

        let currentDate = formatDate(new Date(), 'yyyyMMddHHmmss');
        let finalFilename = `${name}_${currentDate}.csv`
        let blob = new Blob([csv], { type: 'text/csv' });

        const _winNav = window.navigator as any;
        if (_winNav.msSaveOrOpenBlob) {
            _winNav.msSaveBlob(blob, finalFilename);
        } else {
            let elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = finalFilename;
            document.body.appendChild(elem)
            elem.click();
            document.body.removeChild(elem);
        }
    }

    async exportRequested(exportDate: { fromDate: Date, toDate: Date }) {
        if (this.activeTab === 'summary') {
            let exportDataPromise = await Promise.all([
                this.getStateFlowExportData(exportDate.fromDate, exportDate.toDate),
                this.getFacilityFlowExportData(exportDate.fromDate, exportDate.toDate)
            ]);
            let statesData = exportDataPromise[0];
            let facilityData = exportDataPromise[1];
            statesData.filter(x => x.StateShortName == "VIC").forEach(vic => {
                let vicGasDate = vic.GasDate;
                let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                if (vicGasDate < today) {
                    let data = facilityData.filter(x => x.GasDate.getTime() == vicGasDate.getTime() && x.FacilityId == '530110' && [590009, 590008, 590005, 590004, 590007, 590006].includes(x.LocationId));
                    let demand = data.reduce((acc, x) => acc + x.Demand, 0);
                    vic.Demand = demand;
                } else {
                    let data = facilityData.filter(x => x.GasDate.getTime() == vicGasDate.getTime() && x.FacilityId == '530110');
                    let demand = data.reduce((acc, x) => acc + x.Supply - x.Demand + x.TransferIn - x.TransferOut, 0);
                    vic.Demand = demand;
                }
            });

            this.downloadCsv("SupplyDemandSummary", statesData, ['StateShortName', 'StateName', 'LastUpdated', 'GasDate',
                'Demand', 'Supply']);
        } else {
            let reportId = await DataManager.addEndPoint('MapExport',
                { FromDate: exportDate.fromDate, ToDate: exportDate.toDate, GraphType: this.activeTab.toUpperCase() }, undefined, 'data.ExportData',
                undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']);
            let dv = DataManager.getDynamicView(reportId, `${this.activeTab}Export`);
            let list = dv.data();
            this.downloadCsv(`${this.activeTab}Export`, list, ['ReferenceId', 'ReferenceName', 'GasDate', 'Flow', ['pipelines', 'production'].includes(this.activeTab) ? 'Capacity' : 'Balance', 'Utilisation']);
        }

    }
    async getStateFlowExportData(fromDate: Date, toDate: Date) {
        let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        let yesterday = addDays(today, -1);
        let hasPast = fromDate < today;
        let hasFuture = today <= toDate;
        let flowData = await Promise.all([
            hasPast ? DataManager.addEndPoint('StateDailyProductionAndFlow',
                { FromGasDate: fromDate, ToGasDate: toDate < yesterday ? toDate : yesterday }, 1000, 'data.StateDailyProductionAndFlowList',
                undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']) : new Promise<string>((resolve, reject) => { resolve(undefined) }),

            hasFuture ? DataManager.addEndPoint('StateNominationsAndForecasts',
                { FromGasDate: fromDate > today ? fromDate : today, ToGasDate: toDate }, 1000,
                'data.StateNominationsAndForecastsList',
                undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged']) : new Promise<string>((resolve, reject) => { resolve(undefined) }),

        ]);
        let pastId = flowData[0];
        let futureId = flowData[1];
        let pastDataView = hasPast ? DataManager.getDynamicView(pastId, 'stateFlowPastExport') : undefined;
        let futureDataView = hasFuture ? DataManager.getDynamicView(futureId, 'stateFlowFutureExport') : undefined;

        let groupByDateTakeLatest = (dv: CustomDynamicView<any>) => {
            return dv.mapReduce(v => {
                return { ...v, key: `${v.StateShortName}#${v.GasDate.toDateString()}` };
            }, arr => {
                let res: Array<any> = new Array<any>();
                arr.forEach((value, index) => {
                    let foundIndex = res.findIndex(val => val.key == value.key);
                    if (foundIndex != -1 && value.LastUpdated > res[foundIndex].LastUpdated) {
                        res.splice(foundIndex, 1, value);
                    } else {
                        res.push(value);
                    }
                });
                return res;
            })
        };

        let pastData = hasPast ? groupByDateTakeLatest(pastDataView) : [];
        let futureData = hasFuture ? groupByDateTakeLatest(futureDataView) : [];
        return pastData.concat(futureData);
    }

    async getFacilityFlowExportData(fromDate: Date, toDate: Date) {
        let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        let yesterday = addDays(today, -1);
        let hasPast = fromDate < today;
        let hasFuture = today <= toDate;
        let flowData = await Promise.all([
            hasPast ? DataManager.addEndPoint('DailyProductionAndFlow',
                { FromGasDate: fromDate, ToGasDate: toDate < yesterday ? toDate : yesterday }, 1000,
                'data.DailyProductionAndFlowList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged'])
                : new Promise<string>((resolve, reject) => { resolve(undefined) }),

            hasFuture ? DataManager.addEndPoint('NominationsAndForecasts',
                { FromGasDate: fromDate > today ? fromDate : today, ToGasDate: toDate }, 1000,
                'data.NominationsAndForecastsList', undefined, 'YYYY-MM-DDTHH:mm:ssZ', ['GasDate', 'LastChanged'])
                : new Promise<string>((resolve, reject) => { resolve(undefined) }),

        ]);
        let pastId = flowData[0];
        let futureId = flowData[1];
        let pastDataView = hasPast ? DataManager.getDynamicView(pastId, 'stateFlowPastExport') : undefined;
        let futureDataView = hasFuture ? DataManager.getDynamicView(futureId, 'stateFlowFutureExport') : undefined;

        let pastData = hasPast ? pastDataView.data() : [];
        let futureData = hasFuture ? futureDataView.data() : [];
        return pastData.concat(futureData);
    }

}

let projection = d3.geoMercator()
    .center([135, -29])
    .scale(600)
    .translate([412 / 2, 362 / 2])
    .precision(0.1);

Vue.filter('projection', (coordinates: any) => {
    return `translate(${projection([coordinates[0], coordinates[1]])})`;
});


Vue.filter('projectionXY', (coordinates: any) => {
    return projection([coordinates[0], coordinates[1]]);
});



// WEBPACK FOOTER //
// src/components/map/map.ts